import { consoleRequest } from '@/console/api/http'
import {
  OwnerBarcodeSkuLookupRequest,
  OwnerBarcodeSkuLookupResponse,
  ProductOptionSkuLookupRequest,
  ProductOptionSkuLookupResponse,
  SkuBackfillRequest,
  SkuBackfillResponse,
} from '@/console/api/types'

/**
 * 성공 본문에 meta 래퍼가 없어 언랩하지 않고 그대로 돌려준다. 건별 실패도 200 이므로
 * 호출부가 results[].outcome 으로 판정한다(docs/DEV_CONSOLE_SKU_LOOKUP_BACKFILL_API.md §2.3).
 */
export const SKU_LOOKUP_BY_PRODUCT_OPTION_URL = '/api/v1/dev-console/skus/lookup/by-product-option'
export const SKU_LOOKUP_BY_OWNER_BARCODE_URL = '/api/v1/dev-console/skus/lookup/by-owner-barcode'
export const ORDER_PRODUCT_SKU_BACKFILL_URL = '/api/v1/dev-console/order-products/sku-backfill'

export const lookupSkusByProductOption = (request: ProductOptionSkuLookupRequest): Promise<ProductOptionSkuLookupResponse> =>
  consoleRequest.post<ProductOptionSkuLookupResponse, ProductOptionSkuLookupRequest>(SKU_LOOKUP_BY_PRODUCT_OPTION_URL, request)

export const lookupSkusByOwnerBarcode = (request: OwnerBarcodeSkuLookupRequest): Promise<OwnerBarcodeSkuLookupResponse> =>
  consoleRequest.post<OwnerBarcodeSkuLookupResponse, OwnerBarcodeSkuLookupRequest>(SKU_LOOKUP_BY_OWNER_BARCODE_URL, request)

export const backfillOrderProductSkuIds = (request: SkuBackfillRequest): Promise<SkuBackfillResponse> =>
  consoleRequest.post<SkuBackfillResponse, SkuBackfillRequest>(ORDER_PRODUCT_SKU_BACKFILL_URL, request)
